module.exports = __webpack_public_path__ + "fc1fa469470c6b644fc6a213dd767ae1.png";